import { MULTI_QUOTE_DATA, MULTI_QUOTE_ERROR_DATA, MULTI_QUOTE_HIDE_ERROR_DATA, MULTI_QUOTE_START_LOADER, MULTI_QUOTE_STOP_LOADER, } from "../interface/IMultiQuote";
const initialState = {
    multiQuote: {},
    multiQuoteLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const multiQuoteReducers = (state = initialState, action) => {
    switch (action.type) {
        case MULTI_QUOTE_DATA:
            return Object.assign(Object.assign({}, state), { multiQuote: action.payload.multiQuote });
        case MULTI_QUOTE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case MULTI_QUOTE_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case MULTI_QUOTE_START_LOADER:
            return Object.assign(Object.assign({}, state), { multiQuoteLoader: true });
        case MULTI_QUOTE_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { multiQuoteLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default multiQuoteReducers;
